import { render, staticRenderFns } from "./BadExperience.vue?vue&type=template&id=06200754&"
import script from "./BadExperience.vue?vue&type=script&lang=js&"
export * from "./BadExperience.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports